import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Auth } from 'aws-amplify'
import ErrorBlock from '../components/ErrorBlock'
import Spinner from '../components/Spinner'
import LoginForm from './LoginForm'
import ShoppingStep from '../components/membershipRenewalPage/ShoppingStep'
import PaymentStep from '../components/membershipRenewalPage/PaymentStep'
import CompletedStep from '../components/membershipRenewalPage/CompletedStep'
import AuthenticatedAPI from '../lib/authenticatedAPI'

const steps = {
  SIGNIN: 'SIGNIN',
  SHOPPING: 'SHOPPING',
  PAYMENT: 'PAYMENT',
  COMPLETED: 'COMPLETED'
}

const MembershipRenewalPage = ({skus}) => {

  const { SIGNIN, SHOPPING } = steps
  const [isLoading, setIsLoading] = useState(true)
  const [step, setStep] = useState(null)
  const [errorMsg, setErrorMsg] = useState(null)
  const [items, setItems] = useState([])
  const [userInfo, setUserInfo] = useState({})

  useEffect(() => {
    const checkSignedIn = async () => {
      try {
        setUserInfo(await AuthenticatedAPI.get('cphill', '/users'))
        setStep(SHOPPING)
      } catch(error) {
        setStep(SIGNIN)
      } finally {
        setIsLoading(false)
      }
    }
    checkSignedIn()
  }, [])

  const toggleItem = (passType, membershipId) => {
    if (items.map(i => i.membershipId).includes(membershipId))
      setItems(items.filter(item => item.membershipId !== membershipId))
    else 
      setItems([...items, { passType, membershipId, skuToUse: 'renewalSkuId' }])
  }

  if (isLoading)
    return <Spinner />

  return (
    <div className="container mx-auto px-2 md:px-0">
      <div className="lg:w-2/3 xl:w-3/5 md:mt-10 mb-12 mx-auto">
        {errorMsg ? (
          <ErrorBlock headerText="An error occured" descriptionText={errorMsg} />
        ) : {
          SIGNIN: <>
            <div className="mx-auto md:w-1/2">
              <LoginForm afterLoginAction={() => setStep(SHOPPING)} />
            </div>
          </>,
          SHOPPING: <ShoppingStep
            toggleItem={toggleItem}
            steps={steps}
            setStep={setStep}
            items={items}
            skus={skus}
            setErrorMsg={setErrorMsg}
          />,
          PAYMENT: <PaymentStep
            items={items}
            skus={skus}
            setErrorMsg={setErrorMsg}
            steps={steps}
            setStep={setStep}
            userInfo={userInfo}
          />,
          COMPLETED: <CompletedStep
            items={items}
            skus={skus}
          />
        }[step] 
      }
      </div>
    </div>
  );
}

MembershipRenewalPage.propTypes = {
  skus: PropTypes.shape.isRequired
}

export default MembershipRenewalPage